define('viewModels/privileged/base/BaseSupervisorListView',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (ko, ViewModel) {
    'use strict';

    var BaseSupervisorListView = ViewModel.extend(function () {
        var self = this;

        //
        // Layout
        //

        self.filterInputLabel = ko.observable(function () {
            throw 'The method BaseSupervisorListView.filterInputLabel() should be considered abstract.';
        });

        self.selectedLayout = ko.observable("");

        self.templates = ko.observable(function () {
            throw 'The method BaseSupervisorListView.templates() should be considered abstract.';
        });


        self.selectedLayout = ko.observable("");

        self.settingsKey = ko.observable(function () {
            throw 'The method BaseSupervisorListView.settingsKey() should be considered abstract.';
        });

        self.displayedTemplate = self.computed(function () {
            return self.templates()[self.selectedLayout()];
        });

        //
        // Filtering
        //

        self.filterIndex = ko.observableArray([]);

        self.filterList = function () {
            throw 'The method BaseSupervisorListView.filterList(query) should be considered abstract.';
        };

    });

    return BaseSupervisorListView;
});
